import './SFTDashboard.css';

import { Box, Button, CircularProgress, Modal, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { resetTest, setExamId } from '../../store/testSelectionSlice';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid2';
import { LOCAL_BASE_URL } from '../../constants/constants';
import Label from '../atoms/Label';
import TestCard from './TestCard';
import axiosRequestInterceptor from '../../interceptor/axiosAPIRequestInterceptor';
import { logger } from '../../utils/logger';
import { resetExam } from '../../store/ExamSlice';
import { setMainTab } from '../../store/mainTabSlice';
import { useNavigate } from 'react-router-dom';

const SFTDashboard = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const api = axiosRequestInterceptor;

	const [open, setOpen] = useState(false);
	const [SFTTests, setSFTTests] = useState([]);
	const [loading, setLoading] = useState(false);

	const { userId } = useSelector((state) => state.userDetails);

	useEffect(() => {
		const fetchSFTTests = async () => {
			try {
				setLoading(true);
				const response = await api.post(`/sft/getUserSFTTests`, {
					userId: userId,
				});
				logger.log('response.data', response.data);
				setSFTTests(response?.data?.tests);
			} catch (error) {
				logger.log('Error fetching exams:', error);
			} finally {
				setLoading(false);
			}
		};
		fetchSFTTests();
		dispatch(resetExam());
		dispatch(resetTest());
	}, []);

	const handleCreateSFT = () => {
		logger.log('Create SFT clicked');
		setOpen(true);
	};

	const handleClose = (e, tab) => {
		setOpen(false);
		if (tab === 'READING_WRITING' || tab === 'MATHS') {
			dispatch(setMainTab(tab));
			navigate('/SFT/create');
		}
	};

	const hadleViewScore = (testId) => {
		// const id = testId.split("#")[1];
		dispatch(setExamId(testId));
		navigate('/exam-score');
	};

	return (
		<>
			<Box
				sx={{
					paddingLeft: {
						xs: '2.85rem', // ~40% of 7.125rem
						sm: '4.275rem', // ~60% of 7.125rem
						md: '5.7rem',
						lg: '7.125rem',
					},
					paddingRight: {
						xs: '2.45rem', // ~40% of 6.125rem
						sm: '3.675rem', // ~60% of 6.125rem
						md: '4.9rem',
						lg: '6.125rem',
					},
				}}
			>
				<Box
					sx={{
						paddingTop: '6.875rem',
						textAlign: 'start',
						paddingBottom: '2.8125rem',
					}}
				>
					<Typography
						variant="h4"
						fontWeight="bold"
						textAlign="center"
						color="#1F21E6"
						sx={{ textAlign: 'start', paddingBottom: '2.8125rem' }}
					>
						SmartFocus TestBuilder (SFT)
					</Typography>
					<Button
						variant="contained"
						size="large"
						className="create-sft-button"
						sx={{ textTransform: 'none' }}
						onClick={handleCreateSFT}
					>
						Create New SFT
					</Button>
				</Box>
				{loading ? (
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: '200px',
						}}
					>
						<div className="loader"></div>
					</Box>
				) : (
					<Grid
						container
						spacing={8}
						columns={{ xs: 1, sm: 1, md: 1, lg: 2 }}
						// sx={{ display: "flex", flexWrap: "wrap", gap: "4.133rem" }}
					>
						{SFTTests?.length ? (
							SFTTests?.map((test) => (
								<Grid
									size={{ xs: 1, sm: 1, md: 1, lg: 1 }}
									key={test.testId}
									className="testContainer"
								>
									<TestCard
										title={test.testName}
										section={test.testType}
										date={test.createdAt}
										progress={test?.progress || 0}
										id={test.testId}
										hadleViewScore={hadleViewScore}
									/>
								</Grid>
							))
						) : (
							<div className="no-data-message">
								<Label
									label="No tests attempted yet."
									fontSize="20px"
									fontWeight="500"
									color="gray"
								/>
							</div>
						)}
					</Grid>
				)}
			</Box>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={{ paddingTop: '3.5rem', height: '100%' }}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: '70%',
						bgcolor: 'background.paper',
						border: '2px solid #000',
						boxShadow: 24,
						p: 4,
					}}
				>
					<Typography
						variant="h4"
						fontWeight="bold"
						textAlign="center"
						color="#1F21E6"
						sx={{ textAlign: 'start', paddingBottom: '2.8125rem' }}
					>
						SmartFocus TestBuilder (SFT)
					</Typography>
					<p style={{ paddingBottom: '2.8125rem' }}>
						<b>
							Choose your test section: Reading & Writing or Maths—powered by
							SmartFocus TestBuilder.
						</b>
					</p>
					<p
						style={{
							width: '80%',
							textAlign: 'center',
							paddingBottom: '6.4375rem',
						}}
					>
						Ready to challenge yourself? Choose your test section—Reading & Writing or
						Maths— and let SmartFocus TestBuilder tailor the perfect test for you!
					</p>
					<Box
						sx={{
							display: 'flex',
							gap: '1.5rem',
							flexDirection: { xs: 'column', sm: 'row' },
						}}
					>
						<Button
							variant="contained"
							sx={{
								backgroundColor: '#1F21E6',
								color: 'white',
								textTransform: 'none',
								width: '11rem',
								minWidth: '11rem',
							}}
							onClick={(e) => handleClose(e, 'READING_WRITING')}
						>
							Reading & Writing
						</Button>
						<Button
							variant="contained"
							sx={{
								backgroundColor: '#1F21E6',
								color: 'white',
								textTransform: 'none',
								width: '11rem',
								minWidth: '11rem',
							}}
							onClick={(e) => handleClose(e, 'MATHS')}
						>
							Maths
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
};

export default SFTDashboard;
